<template>
  <b-modal
    ref="modal"
    title="Rename"
    centered
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        :disabled="!!error || !name"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    <b-form-group
      label="New name"
      :state="!error"
      :invalid-feedback="error ?? ''"
    >
      <b-form-input
        v-model="name"
        :state="!error"
        @keyup.enter="accept"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import modalMixin from './mixin'
import { createNamespacedHelpers } from 'vuex'
import { MODALS } from '../constants'
import { createModal } from './action-creater'
import { isBriefLinkedFolder } from '../helpers'

const { mapActions, mapMutations } = createNamespacedHelpers('fileBrowser')

export default {
  name: "RenameModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    modalMixin
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    name: '',
    error: null
  }),
  watch: {
    name(value) {
      // general validation, even if needValidation is false
      // we can't have a space only name
      if (!value || !value.trim()) {
        this.error = 'Name cannot be empty'
      } else {
        this.error = null
      }
      
      if (!this.payload.needValidation) {
        return; 
      }
      
      if (/[ ,]/.test(value)) {
        this.error = 'Name cannot contain spaces or commas'
      } else {
        this.error = null
      }
    },
    payload(value) {
      if (!value) {
        return;
      }

      this.name = value.name
      this.error = null;
    }
  },
  methods: {
    ...mapActions(['editFile']),
    ...mapMutations({
      setModal: 'SET_MODAL',
    }),
    async accept() {
      if (this.error || !this.name.trim()) {
        return;
      }

      const nextName = this.name.trim();
      if (
        isBriefLinkedFolder(this.payload)
        && nextName !== this.payload.name
      ) {
        this.close(true);
        this.setModal(createModal(MODALS.BRIEF_FOLDER_RENAME, {
          id: this.payload.id,
          name: nextName,
          brief_title: this.payload.brief_title || this.payload.name,
          brief_id: this.payload.brief_id,
          item: this.payload,
        }));
        return;
      }

      await this.editFile({
        id: this.payload.id,
        name: nextName,
        item: this.payload,
      });
    },
  },
}
</script>
